import React from "react";
import DsasButton from "../../../../../components/DsasButton/DsasButton";
import { Grid, useMediaQuery, useTheme } from "@mui/material";

const SelectCusto = ({ keyValue, event, onChange, options }) => {
   const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  // Découpe options en 2 colonnes (équilibrées)
  const mid = Math.ceil(options.length / 2);
  const column1 = options.slice(0, mid);
  const column2 = options.slice(mid);

  return (
    <div className="select-custo medium-padding">
      <Grid container spacing={2}>
        {isMobile ? (
          // Version mobile : une seule colonne pleine largeur
          options.map((opt) => (
            <Grid item xs={12} key={opt.id}>
              <DsasButton
                focused={event[keyValue] === opt.id}
                label={opt.label}
                variant="alternative"
                customCss={{margin:'5px', width:'100%'}}
                onClick={() => onChange(keyValue, opt.id)}
              />
            </Grid>
          ))
        ) : (
          // Desktop/tablette : 2 colonnes avec moitié des éléments
          <>
            <Grid item xs={6}>
              {column1.map((opt) => (
                <DsasButton
                  key={opt.id}
                  focused={event[keyValue] === opt.id}
                  label={opt.label}
                  variant="alternative"
                  customCss={{margin:'5px', width:'100%'}}
                  onClick={() => onChange(keyValue, opt.id)}
                  fullWidth
                />
              ))}
            </Grid>
            <Grid item xs={6}>
              {column2.map((opt) => (
                <DsasButton
                  key={opt.id}
                  focused={event[keyValue] === opt.id}
                  label={opt.label}
                  variant="alternative"
                  customCss={{margin:'5px', width:'100%'}}
                  onClick={() => onChange(keyValue, opt.id)}
                  fullWidth
                />
              ))}
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default SelectCusto;
